import { useQuery, useQueryClient } from '@tanstack/react-query'
import type { StagingDeepHealthResponse, StagingHealthResponse } from '@/lib/types'

const STAGING_URL = 'https://staging-api.one-email.com'
const HEALTH_REFETCH_MS = 10_000
const DEEP_HEALTH_REFETCH_MS = 30_000

async function fetchStagingHealth(): Promise<StagingHealthResponse> {
  const response = await fetch(`${STAGING_URL}/health`)
  if (!response.ok) {
    throw new Error(`Health check failed: ${response.status}`)
  }
  return response.json() as Promise<StagingHealthResponse>
}

async function fetchStagingDeepHealth(): Promise<StagingDeepHealthResponse> {
  const response = await fetch(`${STAGING_URL}/health/deep`)
  if (!response.ok) {
    throw new Error(`Deep health check failed: ${response.status}`)
  }
  return response.json() as Promise<StagingDeepHealthResponse>
}

export function useStagingHealth() {
  return useQuery<StagingHealthResponse>({
    queryKey: ['staging', 'health'],
    queryFn: fetchStagingHealth,
    refetchInterval: HEALTH_REFETCH_MS,
    retry: 1,
  })
}

export function useStagingDeepHealth() {
  return useQuery<StagingDeepHealthResponse>({
    queryKey: ['staging', 'deepHealth'],
    queryFn: fetchStagingDeepHealth,
    refetchInterval: DEEP_HEALTH_REFETCH_MS,
    retry: 1,
  })
}

export function useRefreshStaging() {
  const queryClient = useQueryClient()
  return () => {
    void queryClient.invalidateQueries({ queryKey: ['staging'] })
  }
}
